import { gql } from '@apollo/client';

export const CHANGE_STREAM_MODE = gql`
  mutation ChangeStreamMode($id: ID!, $mode: StreamModeEnum!) {
    changeStreamMode(id: $id, mode: $mode) {
      id
      slug
      mode
      rtmpIngestURL
      rtmpIngestKey
      rtmpPlaybackUrl
    }
  }
`;
